import { IEmployees } from "./models";

export const employeeItems: IEmployees[] = [
  {
    id: "1",
    sector: "100",
  },
  {
    id: "2",
    sector: "200",
  },
];
